import React, { Dispatch, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Column, Edge } from "../constants";
import HeaderSubCell from "./headerSubCell";

export const RenderNestedHeader = ({
  parentColumn,
  parentId,
  setSelectedColumns,
  activeFilterDropdownId,
  setActiveFilterDropDownId,
  selectedTableColumns,
}: {
  parentColumn?: Column;
  parentId?: string;
  setSelectedColumns: Dispatch<React.SetStateAction<Column[]>>;
  activeFilterDropdownId: string;
  setActiveFilterDropDownId: Dispatch<React.SetStateAction<string>>;
  selectedTableColumns?: Column[];
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const column = (parentColumn as any)?.child;
  const handleDropdown = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setDropdownPosition({
      top: rect.bottom,
      left: rect.left,
    });
    setShowDropdown(!showDropdown);
  };

  const addChild = (selectedItem: Column) => {
    setSelectedColumns((prev) => {
      const columnList = [...prev];
      let item: Column = { ...selectedItem };
      const selectedColumn = columnList?.find((item) => item?.id === parentId);
      if (
        (selectedItem as Edge)?.infinite &&
        (selectedItem as Edge)?.columns.length === 0
      ) {
        item = {
          ...(selectedItem as Edge),
          columns: (selectedColumn as Edge)?.columns,
        };
      }
      const recursiveSearch = (column?: Column) => {
        if (column?.id === parentColumn?.id) {
          (column as Edge).child = { ...item, id: uuidv4() };
          return;
        }
        (column as Edge).child && recursiveSearch((column as Edge)?.child);
      };
      recursiveSearch(selectedColumn);
      return columnList;
    });
  };

  if (!column) {
    return (
      <HeaderSubCell
        selectedTableColumns={selectedTableColumns}
        handleDropdown={handleDropdown}
        setShowDropdown={setShowDropdown}
        column={column}
        showDropdown={showDropdown}
        parentColumn={parentColumn}
        addChild={addChild}
        dropdownPosition={dropdownPosition}
        activeFilterDropdownId={activeFilterDropdownId}
        setActiveFilterDropDownId={setActiveFilterDropDownId}
        setSelectedColumns={setSelectedColumns}
        parentId={parentId}
      />
    );
  }

  return (
    <div>
      <HeaderSubCell
        selectedTableColumns={selectedTableColumns}
        handleDropdown={handleDropdown}
        setShowDropdown={setShowDropdown}
        column={column}
        showDropdown={showDropdown}
        parentColumn={parentColumn}
        addChild={addChild}
        dropdownPosition={dropdownPosition}
        activeFilterDropdownId={activeFilterDropdownId}
        setActiveFilterDropDownId={setActiveFilterDropDownId}
        setSelectedColumns={setSelectedColumns}
        parentId={parentId}
      />
      {column?.type === "edge" && (
        <RenderNestedHeader
          selectedTableColumns={selectedTableColumns}
          parentColumn={column}
          parentId={parentId}
          setSelectedColumns={setSelectedColumns}
          activeFilterDropdownId={activeFilterDropdownId}
          setActiveFilterDropDownId={setActiveFilterDropDownId}
        />
      )}
    </div>
  );
};
